
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
          <img 
            src="https://public.readdy.ai/ai/img_res/7eba06d2-2703-459d-ada7-85a913ba6307.png" 
            alt="Simone Santos Psicóloga" 
            className="h-12 w-auto"
          />
        </div>
        
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('sobre')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#A8D5E2]' : 'text-white hover:text-[#F4C2C2]'
            }`}
          >
            Sobre
          </button>
          <button
            onClick={() => scrollToSection('abordagem')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#A8D5E2]' : 'text-white hover:text-[#F4C2C2]'
            }`}
          >
            Abordagem
          </button>
          <button
            onClick={() => scrollToSection('areas')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#A8D5E2]' : 'text-white hover:text-[#F4C2C2]'
            }`}
          >
            Áreas de Atuação
          </button>
          <button
            onClick={() => scrollToSection('servicos')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#A8D5E2]' : 'text-white hover:text-[#F4C2C2]'
            }`}
          >
            Serviços
          </button>
          <a
            href="https://wa.me/5511959099459"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#A8D5E2] text-gray-800 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#8FC5D4] transition-colors whitespace-nowrap cursor-pointer"
          >
            Agendar Atendimento
          </a>
        </div>

        <button className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer">
          <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
        </button>
      </div>
    </nav>
  );
}
